
















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';
import Toggle from '@/views/document/section/Toggle.vue';

@Component({components: {Toggle, List}})
export default class Sustainability extends Vue {
  @Prop() readonly group!: any;

  @Watch('notesSection', {immediate: true, deep: true})
  onData1() {
    this.onData();
  }
  @Watch('compassSection', {immediate: true, deep: true})
  onData2() {
    this.onData();
  }
  @Watch('sustainability', {immediate: true, deep: true})
  onData3() {
    this.onData();
  }

  onData() {
    // if (!this.sustainability && !this.compassSection.Hidden) {
    //   this.compassSection.Hidden = true;
    // }
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get notesSection(): ListSection {
    return dokument.getItem(49) as ListSection;
  }

  get compassSection(): any {
    return dokument.getItem(48);
  }

  get sustainabilityImpactSection(): any {
    return dokument.getItem(50);
  }

  get sustainabilityQuestionsSection(): any {
    return dokument.getItem(51);
  }

  get sustainabilityProcessSection(): any {
    return dokument.getItem(52);
  }

  get hidden(): boolean {
    // if (!this.sustainability) {
    //   return true;
    // }
    return this.notesSection.Hidden === true &&
        this.compassSection.Hidden === true &&
        this.sustainabilityImpactSection.Hidden === true &&
        this.sustainabilityQuestionsSection.Hidden === true &&
        this.sustainabilityProcessSection.Hidden === true;
  }

  get sustainability(): boolean {
    return !!(dokument.sustainability && dokument.sustainability.Groups);

  }
}
